class TableGridIconExtendedCellController {
  constructor() {
    this.name = 'tableGridTextExtendedCell';
  }

  getExtendedValue(row, extendedConfig) {
    return extendedConfig.value(row);
  }

  getIconStructure(row, extendedConfig) {
    return extendedConfig.icon? extendedConfig.icon(row) : false;
  }
  getAdditionalClass(row, extendedConfig) {
    return extendedConfig.class? extendedConfig.class(row) : '';
  }
}

export default TableGridIconExtendedCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridIconExtendedCell/tableGridIconExtendedCell.controller.js